import React, { useCallback } from 'react'
import { Main, MainTop, MainBody, WhiteBox, BoxHeader } from '@/components/Layout'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ChangeItemFileAttachments } from '@/components/changeRequests/fileAttachments'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { Row, Col } from 'reactstrap'
import { PersonSelection } from '@/components/demographics/personSelection'
import { ScopeDetailHeader } from '@/components/changeRequests/scopeDetailHeader'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { useLocalization } from '@/hooks/localization'

function FineDetail ({ match }) {
  return (
    <FormLoader match={match} loader={context.api.fineService.get} render={(formProps) => <FineDetailForm {...formProps} />} />
  )
}

const FineDetailForm = React.memo(function FineDetailForm (props) {
  const { targetId } = props
  const [date] = usePropertyReader(['date'])
  const { localize } = useLocalization()
  const getAttachmentsTableData = useCallback((req) => context.api.fineService.getAttachmentsTableData(targetId, req), [targetId])
  return (
    <Main>
      <MainTop>
        <ScopeDetailHeader title='Fines.FineDetailTitle' backUrl='/fines' />
      </MainTop>
      <MainBody transparent>
        <ValidationBoundary>
          <WhiteBox>
            <Row>
              <Col lg={6}>
                <FormRow label='Fines.Type' name='penaltySource' inputType='lookup' dataSource={context.cache.getPenaltySources} clientSide isCodeList required />
                <PersonSelection required />
                <FormRow
                  label='Common.Date' name='date' inputType='date'
                  required
                  onValidate={x => x.value && x.value > date && 'Validations.InvalidDate'} />
                <FormRow
                  label='Common.Amount'
                  name='amount'
                  inputType='number'
                  inputProps={{ min: 0 }}
                  required />
                <FormRow label='Fines.Status' name='fineStatus' inputType='lookup' dataSource={context.cache.getFineStatuses} clientSide isCodeList required />
              </Col>
              <Col lg={6}>
                <FormRow label='Common.Reason' name='reason' inputType='textarea' required />
                <FormRow label='Common.Description' name='description' inputType='textarea' required />
              </Col>
            </Row>
            <BoxHeader className='header'>{localize('Common.Attachments')}</BoxHeader>
            <ChangeItemFileAttachments
              target={props.target}
              name='attachments'
              dataSource={getAttachmentsTableData}
              downloadAction={context.api.fineService.download}
              simpleView
              attachmentsView />
          </WhiteBox>
        </ValidationBoundary>
      </MainBody>
    </Main>
  )
})

export {
  FineDetail
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/fines/detail.js